export default __webpack_public_path__ + "9750a08c2f1d039495135c8f39edfcec.png";